import { createSimpleFunctional } from '../../util/helpers'

const Footer = createSimpleFunctional('footer', 'footer')

export default {
  Footer
}



// WEBPACK FOOTER //
// ./src/components/footer/index.js